<ng-container [ngTemplateOutlet]="suitableBaseOnScore ? score : suitable">
</ng-container>

<ng-template #score>
  @if (isInRange(suitableBaseOnScore, pack)) {
    <div class="pr-sum-etiquette">
      <div>
        {{
          isInRange(suitableBaseOnScore, pack)
            ? 'Le plus adapté à votre situation'
            : 'Le plus populaire'
        }}
      </div>
    </div>
  }
</ng-template>
<ng-template #suitable>
  @if (recommendationLabel) {
    <div class="pr-sum-etiquette">
      <div>{{ recommendationLabel }}</div>
    </div>
  }
</ng-template>

<!-- Images à revoir, il manque defensif -->

<div
  class="pack-header"
  [style.background-image]="'url(' + pack.img + ')'"
></div>
<div
  class="pack-body"
  [ngClass]="isConsultant && simulationType == 'scpi' ? 'body-consultant' : ''"
>
  <p class="pack-name fw-600">{{ pack.name }}</p>
  <ng-container
    [ngTemplateOutlet]="!pack.id ? customPackTemplate : packTemplate"
  ></ng-container>
</div>

<!-- TEMPLATES -->
<ng-template #packTemplate>
  <p class="text-secondary mbl text-overflow-scroll">
    {{ pack.description ? pack.description : '' }}
  </p>

  @if (isConsultant && simulationType == 'scpi') {
    @for (allocation of _.slice(pack.allocation, 0, 4); track allocation) {
      <ng-container
        [ngTemplateOutlet]="allocationRow"
        [ngTemplateOutletContext]="{ $implicit: allocation }"
      ></ng-container>
    }
  }
  <ng-container
    [ngTemplateOutlet]="
      simulationType == 'scpi' ? scpiTypeTemplate : lifeInsuranceTypeTemplate
    "
  >
  </ng-container>
</ng-template>

<ng-template #allocationRow let-allocation>
  <div class="d-flex justify-content-space-between pvxs">
    <span class="prxs fs-14 text-ellipsis" [tooltip]="allocation.name">{{
      allocation.name
    }}</span>
    <!-- <div class="d-flex align-items-center">
    <div
      *ngFor="let block of _.range(5); let i = index"
      class="pack-block"
        [ngClass]="{
          active: i < Math.ceil(allocation.allocationPercentage * 10)
        }"
    ></div>
    <span class="mlm"
      >{{ Math.round(allocation.allocationPercentage * 100) }}%</span
      >
    </div> -->
    <div class="d-flex align-items-center alloc">
      <progress
        class="progress-bar"
        [value]="allocation.allocationPercentage"
        max="1"
      ></progress>
      <span class="fs-14 fw-400"
        >{{ Math.round(allocation.allocationPercentage * 100) }}%</span
      >
    </div>
  </div>
</ng-template>

<ng-template #customPackTemplate>
  <div class="text-center">
    <!-- <img src="assets/img/simulators/scpi_pack.png" alt="" /> -->
    <p class="text-secondary">{{ customPack.description }}</p>
    <pr-button display="neutral" size="lg" (click)="selectCustomPack()">{{
      customPack.buttonText
    }}</pr-button>
  </div>
</ng-template>

<ng-template #scpiTypeTemplate>
  <div class="d-flex flex-column gap-s">
    <div class="pack-label">
      <span class="fs-16 fw-500 full-w d-flex justify-content-space-between"
        >Taux de distribution
        <span class="fw-600">{{
          pack.meanExpectedRateDVM | percent: '.0-2'
        }}</span>
      </span>
    </div>

    <div class="pack-label min-sub">
      <span class="fs-16 fw-500 full-w d-flex justify-content-space-between"
        >Minimum souscription
        <span class="fw-600">{{
          pack.minimumSubscriptionAmount | currency: 'EUR' : 'symbol' : '1.0-0'
        }}</span>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #lifeInsuranceTypeTemplate>
  <div class="d-flex flex-column gap-s">
    <div class="d-flex justify-content-space-between pvxs perf">
      <span class="fs-14 green-text">Objectif de performance</span>

      <span class="green-text">± {{ perfPack(pack) }}%/an</span>
    </div>
    <div class="d-flex gap-s flex-column justify-content-space-between pvxs">
      <span class="fs-14">Niveau de risque </span>
      <div class="d-flex">
        <pr-risk-level-ladder
          class="risk-life-insurance"
          [range]="pack?.riskScore"
        ></pr-risk-level-ladder>
      </div>
    </div>
    <!-- <div class="d-flex justify-content-space-between pvxs">
      <span class="fs-14">Nombre de supports</span>
      <span>{{ pack.allocation.length }}</span>
    </div>  -->
  </div>
</ng-template>
